// WindowContext.js
import React, { createContext, useContext, useState, useCallback } from "react";
import merge from "lodash/merge";

const WindowDataContext = createContext();

export const WindowDataProvider = ({ children }) => {
	const [windowData, setWindowData] = useState({});

	const setWindowContent = useCallback((windowId, newData) => {
		setWindowData((prevData) => {
			const currentWindowData = prevData[windowId] || {};

			const resolvedNewData =
				typeof newData === "function" ? newData(currentWindowData) : newData;

			if (currentWindowData === resolvedNewData) {
				return prevData;
			}

			if (resolvedNewData === null) {
				if (!currentWindowData) {
					return prevData;
				}
				const { [windowId]: _, ...remainingData } = prevData;
				return remainingData;
			}

			return {
				...prevData,
				[windowId]: merge({}, currentWindowData, resolvedNewData),
			};
		});
	}, []);


	const getWindowContent = useCallback(
		(windowId) => {
			return windowData[windowId] || {};
		},
		[windowData]
	);

	return (
		<WindowDataContext.Provider value={{ setWindowContent, getWindowContent }}>
			{children}
		</WindowDataContext.Provider>
	);
};




export const useWindowData = () => useContext(WindowDataContext);
